module.exports = __webpack_public_path__ + "img/custom_bg2.58c9d00f.png";